import { FC, ReactNode } from 'react';

import { Header } from './Header';
import { Sidebar } from './Sidebar';

const Layout: FC<{ children: ReactNode }> = ({ children }) => (
    <div className="shell">
        <div className="complements">
            <div data-overlay-container className="complement">
                <header>
                    <div className="layout">
                        <Header />
                    </div>
                </header>
            </div>
            <div data-overlay-container className="complement">
                <div className="layout">
                    <Sidebar />
                </div>
            </div>
        </div>
        <div>
            <div className="layout">
                <div className="dashboard">
                    <main
                        tabIndex={-1}
                        className="main"
                        style={{ paddingTop: 8, paddingBottom: 8 }}
                    >
                        <div className="main__content">
                            {children}
                        </div>
                    </main>
                </div>
            </div>
        </div>
    </div>
);

export { Layout };
